import { Dropdown, useInputValidation } from '@landsbankinn/ui';
import React, { useMemo } from 'react';

interface IProps {
  deliveryPlaceOptions: {
    label: string;
    options: { label: string; value: string }[];
  }[];

  selectedId?: string;
  setSelcetedId: (id: string) => void;
}

export function Location({
  deliveryPlaceOptions,
  selectedId,
  setSelcetedId,
}: IProps) {
  const value = useMemo<{ label: string; value: string } | undefined>(() => {
    let seletedOption = undefined;
    if (selectedId !== '') {
      deliveryPlaceOptions.forEach((i) => {
        const item = i.options.find((o) => o.value === selectedId);
        if (item) {
          seletedOption = item;
        }
      });
    }

    return seletedOption;
  }, [selectedId, deliveryPlaceOptions]);

  const [_, isValid] = useInputValidation(selectedId, [
    { validation: (id) => (id ? id.length > 0 : false) },
  ]);

  return (
    <Dropdown
      isValid={isValid}
      label="Hvert viltu sækja kortið?"
      options={deliveryPlaceOptions}
      placeholder="Veldu afhendingastað"
      onChange={(val) => {
        setSelcetedId(val?.['value'] ?? '');
      }}
      value={value}
      buildOption={(val) => val}
      variant="noBorder"
      labelVariant="aboveInput"
    />
  );
}
